import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/live/chat',
  owner: '/home',
  authority: 'chatList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};